import { IApplicationState } from '../../types/redux';

export const getAnswerById = (id: string) => (state: IApplicationState) => {
  return state.answers[id];
};
